export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">追瓜神器</h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
              下载每日吃瓜移动端，随时随地追更最新明星大瓜视频。支持离线缓存、推送提醒、弹幕互动，吃瓜体验全面升级。新用户注册即享7天VIP免费体验，海量高清瓜视频随心看！
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-white rounded-lg cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-fill text-xl"></i>
                <div className="text-left">
                  <div className="text-[10px] leading-none opacity-70">Download on the</div>
                  <div className="text-sm font-semibold leading-tight whitespace-nowrap">App Store</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-white rounded-lg cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-google-play-fill text-xl"></i>
                <div className="text-left">
                  <div className="text-[10px] leading-none opacity-70">GET IT ON</div>
                  <div className="text-sm font-semibold leading-tight whitespace-nowrap">Google Play</div>
                </div>
              </div>
            </div>
            <div className="mt-5 flex items-center justify-center lg:justify-start gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-download-line text-accent-500"></i> 50万+ 下载
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-accent-500"></i> 4.8 评分
              </span>
            </div>
          </div>

          <div className="flex-shrink-0 w-56 md:w-64">
            <div className="relative rounded-2xl overflow-hidden border-4 border-background-200 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20modern%20entertainment%20news%20app%20interface%20with%20warm%20coral%20accent%20colors%2C%20clean%20mobile%20UI%20design%2C%20dark%20mode%20theme%2C%20video%20thumbnails%20layout%2C%20minimalist%20design%20aesthetic%2C%20no%20text&width=600&height=900&seq=app-mockup-gossip&orientation=portrait"
                alt="每日吃瓜移动端APP界面预览"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}